
var csrf = document.querySelector('meta[name="csrf-token"]').content;
let base_url = $('#base_url').val()

window.editPaidQuery = function(queryId)
{
   let query_id = queryId;
   $('.modal-one-title').html('Edit Query');
   $.ajax({
    url: base_url + '/edit-paid-query',
    data: { query_id: queryId},
    dataType: 'html',
    headers: {
        'X-CSRF-Token': csrf
    },
    type: 'post',
    success: function (data) {
        $('.modal-one-body').html(data);
        $('#modal-one').modal('show');
    },
});
}